export default {
  // BalanceTransferYear: 1, // Kết chuyển số dư cuối năm
  // PerformanceResultDefined: 4, // Xác định kết quả hoạt động
  ReceiptWrite: 0, // Ghi thu
  PaymentWrite: 1, // Ghi chi
  Advance: 2, // Thanh toán tạm ứng
  TranferClosing: 3, // Kết chuyển cuối năm
  TranferReceiptClear: 4, // Kết chuyển thu, chi ngân sách xã
  TranferReceiptClearInMonth13: 5, // Kết chuyển thu, chi ngân sách xã trong thời gian chỉnh lý
  TransferBegining: 6, // Quyết toán dự toán chi ngân sách cuối năm
  TransferActivity: 7, // Kết chuyển hoạt động sự nghiệp
  TransferBudgetBalance: 8, // Kết chuyển kết dư sang thu ngân sách xã
  TransferExtraBudget: 10, // Kết chuyển kết dư ngân sách xã
  TransferExtraBudgetInMonth13: 11, // Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý
  AdvancePaymentInMonth13: 12, // Thanh toán tạm ứng trong thời gian chỉnh lý
};
